import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import { getKey } from "../helpers/sessionKey";
import AccountInfo from "../pages/Account/AccountInfo";
import CreateAccount from "../pages/Account/CreateAccount";
import EditAccount from "../pages/Account/EditAccount";
import ChartsOfAccounts from "../pages/ChartsOfAccounts";
import Dashboard from "../pages/Dashboard";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import GeneralLegder from "../pages/GeneralLegder/LedgerAccount";
import CreateJournalEntry from "../pages/JournalEntry/Create";
import EditJournalEntry from "../pages/JournalEntry/Edit";
import JournalEntry from "../pages/JournalEntry/List";
import ProfitAndLoss from "../pages/ProfitAndLoss";
import BankPayment from "../pages/Transaction/Bank/BankPayment";
import BankReceipt from "../pages/Transaction/Bank/BankReceipt";
import CashPayment from "../pages/Transaction/Cash/CashPayment";
import CashReceipt from "../pages/Transaction/Cash/CashReceipt";
import TrialBalance from "../pages/TrialBalance/TrialBalanceDetail";
//@ts-ignore
import { WelcomeRouterService } from "@careinfo/welcome-page-service";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import BalanceSheet from "../pages/BalanceSheet";
import PurchaseRegister from "../pages/CBMSReports/PurchaseRegister";
import PurchaseReturnRegister from "../pages/CBMSReports/PurchaseReturnRegister";
import SalesRegister from "../pages/CBMSReports/SalesRegister";
import SalesReturnRegister from "../pages/CBMSReports/SalesReturnRegister";
import CreditNote from "../pages/CreditNote";
import CreateCreditNote from "../pages/CreditNote/CreateCreditNote";
import EditCreditNote from "../pages/CreditNote/EditCreditNote";
import DebitNote from "../pages/DebitNote";
import CreateDebitNote from "../pages/DebitNote/CreateDebitNote";
import EditDebitNote from "../pages/DebitNote/EditDebitNote";
import LedgerParty from "../pages/GeneralLegder/LedgerParty";
import InventoryInfo from "../pages/InventoryInfo";
import AddProduct from "../pages/InventoryInfo/AddProduct";
import EditProduct from "../pages/InventoryInfo/EditProduct";
import ProductGroupList from "../pages/InventoryInfo/ProductGroupList";
import StockLedgerDetail from "../pages/InventoryReport/StockLedgerDetail";
import StockMovement from "../pages/InventoryReport/StockMovementGroup";
import StockMovementNormal from "../pages/InventoryReport/StockMovementNormal";
import StockTrial from "../pages/InventoryReport/StockTrialGroup";
import StockTrialNormal from "../pages/InventoryReport/StockTrialNormal";
import StockValuationDetail from "../pages/InventoryReport/StockValuationDetail";
import StockValuation from "../pages/InventoryReport/StockValuationGroup";
import StockValuationNormal from "../pages/InventoryReport/StockValuationNormal";
import StockLedgerNormal from "../pages/InventoryReport/StoclLedgerNormal";

import Profile from "../pages/Profile";
import AddPurchase from "../pages/Purchase/AddPurchase";
import EditDraftPurchase from "../pages/Purchase/EditDraftPurchase";
import PurchaseList from "../pages/Purchase/PurchaseList";
import PurchaseReturnList from "../pages/PurchaseReturn";
import AddPurchaseReturn from "../pages/PurchaseReturn/AddPurchaseReturn";
import EditPurchaseReturn from "../pages/PurchaseReturn/EditPurchaseReturn";
import Sales from "../pages/Sales";
import AddSales from "../pages/Sales/AddSales";
import EditDraftSales from "../pages/Sales/EditDraftSales";
import SalesReturn from "../pages/SalesReturn";
import AddSalesReturn from "../pages/SalesReturn/AddSalesReturn";
import EditSalesReturn from "../pages/SalesReturn/EditSalesReturn";
import ServiceInfo from "../pages/ServiceInfo";
import AddService from "../pages/ServiceInfo/CreateServiceInfo";
import EditServiceInfo from "../pages/ServiceInfo/EditServiceInfo";
import ServiceReport from "../pages/ServiceReport";
import Configuration from "../pages/Setup/Configuration";
import Setting from "../pages/Setup/Setting";
import CreateBankPayment from "../pages/Transaction/Bank/CreateBankPayment";
import CreateBankReceipt from "../pages/Transaction/Bank/CreateBankReceipt";
import EditBankPayment from "../pages/Transaction/Bank/EditBankPayment";
import EditBankReceipt from "../pages/Transaction/Bank/EditBankReceipt";
import CreateCashPayment from "../pages/Transaction/Cash/CreateCashPayment";
import CreateCashReceipt from "../pages/Transaction/Cash/CreateCashReceipt";
import EditCashPayment from "../pages/Transaction/Cash/EditCashPayment";
import EditCashReceipt from "../pages/Transaction/Cash/EditCashReceipt";
import TrialBalanceGroup from "../pages/TrialBalance/TrialBalanceGroup";
import DailyNoteRouter from "./DailyNoteRouter";
import {
  AccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";
import CustomerList from "../pages/Customer/CustomerList";
import SupplierList from "../components/Supplier/Supplier";
import SupplierListPage from "../pages/Supplier/SupplierList";
import CreateCustomer from "../pages/Customer/CreateCustomer";
import EditCustomer from "../pages/Customer/EditCustomer";
import EditSupplierUser from "../pages/Supplier/EditSupplierUser";
import CreateSupplier from "../pages/Supplier/CreateSupplier";
import PartySummary from "../pages/GeneralLegder/PartySummary";
export const queryClient = new QueryClient();

const Router = () => {
  const shouldShowWelcome = getKey("shouldShowWelcome");

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route
            path={"/"}
            element={
              shouldShowWelcome === "true" || shouldShowWelcome === null ? (
                <WelcomeRouterService />
              ) : (
                <Dashboard />
              )
            }
          />
          <Route path="/accounting" element={<Dashboard />} />
          <Route
            path={"/accounting/journal-voucher"}
            element={<JournalEntry />}
          />
          <Route
            path={"/journal-voucher/create"}
            element={<CreateJournalEntry />}
          />
          <Route
            path={"/accounting/journal-voucher/edit/:id"}
            element={<EditJournalEntry />}
          />
          <Route
            path={"/accounting/general-ledger-account"}
            element={<GeneralLegder />}
          />
          <Route
            path={"/daily-notes"}
            element={
              <AccessControl
                children={<DailyNoteRouter />}
                allowedPermissions={["can_view_consignment"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/daily-notes/create"}
            element={
              <AccessControl
                children={<DailyNoteRouter />}
                allowedPermissions={["can_view_consignment"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/daily-notes/edit/:id"}
            element={
              <AccessControl
                children={<DailyNoteRouter />}
                allowedPermissions={["can_view_consignment"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/accounting/general-ledger-party"}
            element={<LedgerParty />}
          />
          <Route
            path={"/accounting/general-ledger-party-summary"}
            element={<PartySummary />}
          />
          <Route
            path={"/accounting/balance-sheet"}
            element={<BalanceSheet />}
          />
          <Route
            path={"/accounting/profit-and-loss"}
            element={<ProfitAndLoss />}
          />
          <Route
            path={"/accounting/trial-balance-detail"}
            element={<TrialBalance />}
          />
          <Route
            path={"/accounting/trial-balance-grouped"}
            element={<TrialBalanceGroup />}
          />
          <Route
            path={"/accounting/charts-of-accounts"}
            element={<ChartsOfAccounts />}
          />
          <Route path={"/accounting/profile"} element={<Profile />} />
          <Route path={"/accounting/settings"} element={<Setting />} />
          <Route path="/*" element={<PageNotFound />} />
          <Route path={"/accounting/account"} element={<AccountInfo />} />
          <Route
            path={"/accounting/account/create"}
            element={<CreateAccount />}
          />
          <Route
            path={"/accounting/account/edit/:id"}
            element={<EditAccount />}
          />
          <Route path={"/accounting/bank-payment"} element={<BankPayment />} />
          <Route
            path={"/accounting/bank-payment/create"}
            element={<CreateBankPayment />}
          />
          <Route
            path={"/accounting/bank-payment/edit/:id"}
            element={<EditBankPayment />}
          />
          <Route path={"/accounting/cash-payment"} element={<CashPayment />} />
          <Route
            path={"/accounting/cash-payment/create"}
            element={<CreateCashPayment />}
          />
          <Route
            path={"/accounting/cash-payment/edit/:id"}
            element={<EditCashPayment />}
          />
          <Route path={"/accounting/cash-receipt"} element={<CashReceipt />} />
          <Route
            path={"/accounting/cash-receipt/create"}
            element={<CreateCashReceipt />}
          />
          <Route
            path={"/accounting/cash-receipt/edit/:id"}
            element={<EditCashReceipt />}
          />
          <Route path={"/accounting/bank-receipt"} element={<BankReceipt />} />
          <Route
            path={"/accounting/bank-receipt/create"}
            element={<CreateBankReceipt />}
          />
          <Route
            path={"/accounting/bank-receipt/edit/:id"}
            element={<EditBankReceipt />}
          />
          <Route path={"/accounting/customer"} element={<CustomerList />} />
          <Route path={"/accounting/supplier"} element={<SupplierListPage />} />

          <Route path={"/accounting/sales"} element={<Sales />} />
          <Route path={"/accounting/sales/create"} element={<AddSales />} />
          <Route
            path={"/accounting/sales/edit/:id"}
            element={<EditDraftSales />}
          />
          <Route path={"/accounting/sales-return"} element={<SalesReturn />} />
          <Route
            path={"/accounting/sales-return/create"}
            element={<AddSalesReturn />}
          />
          <Route
            path={"/accounting/sales-return/edit/:id"}
            element={<EditSalesReturn />}
          />
          <Route path={"/accounting/credit-note"} element={<CreditNote />} />
          <Route
            path={"/accounting/credit-note/create"}
            element={<CreateCreditNote />}
          />
          <Route
            path={"/accounting/credit-note/edit/:id"}
            element={<EditCreditNote />}
          />
          <Route path={"/accounting/debit-note"} element={<DebitNote />} />
          <Route
            path={"/accounting/debit-note/create"}
            element={<CreateDebitNote />}
          />
          <Route
            path={"/accounting/debit-note/edit/:id"}
            element={<EditDebitNote />}
          />
          <Route
            path={"/accounting/purchase-return"}
            element={<PurchaseReturnList />}
          />
          <Route
            path={"/accounting/purchase-return/create"}
            element={<AddPurchaseReturn />}
          />
          <Route
            path={"/accounting/purchase-return/edit/:id"}
            element={<EditPurchaseReturn />}
          />
          <Route path={"/accounting/purchase"} element={<PurchaseList />} />
          <Route
            path={"/accounting/purchase/create"}
            element={<AddPurchase />}
          />
          <Route
            path={"/accounting/purchase/edit/:id"}
            element={<EditDraftPurchase />}
          />
          <Route
            path={"/accounting/debit-note/create"}
            element={<CreateDebitNote />}
          />
          <Route
            path={"/accounting/customer/create"}
            element={<CreateCustomer />}
          />
          <Route
            path={"/accounting/supplier/create"}
            element={<CreateSupplier />}
          />
          <Route path={"/accounting/inventory"} element={<InventoryInfo />} />
          <Route path={"/accounting/service"} element={<ServiceInfo />} />
          <Route
            path={"/accounting/purchase-register"}
            element={<PurchaseRegister />}
          />
          <Route
            path={"/accounting/sales-register"}
            element={<SalesRegister />}
          />
          <Route
            path={"/accounting/sales-return-register"}
            element={<SalesReturnRegister />}
          />
          <Route
            path={"/accounting/purchase-return-register"}
            element={<PurchaseReturnRegister />}
          />
          <Route
            path={"/accounting/product-group"}
            element={<ProductGroupList />}
          />
          <Route
            path={"/accounting/stock-trial-group"}
            element={<StockTrial />}
          />
          <Route
            path={"/accounting/stock-valuation-group"}
            element={<StockValuation />}
          />
          <Route
            path={"/accounting/stock-valuation-normal"}
            element={<StockValuationNormal />}
          />
          <Route
            path={"/accounting/stock-valuation-detail"}
            element={<StockValuationDetail />}
          />
          <Route
            path={"/accounting/stock-movement-group"}
            element={<StockMovement />}
          />
          <Route
            path={"/accounting/stock-ledger-normal"}
            element={<StockLedgerNormal />}
          />
          <Route
            path={"/accounting/stock-ledger-detail"}
            element={<StockLedgerDetail />}
          />
          <Route
            path={"/accounting/stock-movement-normal"}
            element={<StockMovementNormal />}
          />
          <Route
            path={"/accounting/stock-trial-normal"}
            element={<StockTrialNormal />}
          />
          <Route
            path={"/accounting/inventory/create"}
            element={<AddProduct />}
          />
          <Route path={"/accounting/service/create"} element={<AddService />} />
          <Route
            path={"/accounting/service-report"}
            element={<ServiceReport />}
          />
          <Route
            path={"/accounting/inventory/edit/:id"}
            element={<EditProduct />}
          />
          <Route
            path={"/accounting/service/edit/:id"}
            element={<EditServiceInfo />}
          />
          <Route
            path={"/accounting/customer/edit/:id"}
            element={<EditCustomer />}
          />
          <Route
            path={"/accounting/supplier/edit/:id"}
            element={<EditSupplierUser />}
          />
          <Route
            path={"/accounting/configuration"}
            element={<Configuration />}
          />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default Router;

